export default "/images/vendor/flag-icon-css/flags/1x1/de.svg?8406691444ff98ee33d4f6cc86cb0372";